const STAFF_ROLES = ["admin", "manager", "relationship_manager", "broker"];

export const parseStaffApiError = (body, fallback = "Something went wrong. Please try again.") => {
	if (!body) return fallback;
	if (typeof body === "string") return body;
	if (body.message) return body.message;
	if (body.error) return body.error;
	if (body.data?.message) return body.data.message;
	if (typeof body === "object") {
		const parts = Object.entries(body).map(([key, value]) => {
			if (Array.isArray(value)) return `${key}: ${value.join(" ")}`;
			return `${key}: ${value}`;
		});
		if (parts.length) return parts.join("; ");
	}
	return fallback;
};

/** Apply authenticate / reset-password success payload to Redux and navigate home. */
export const applyStaffLoginResponse = ({
	responseBody,
	dispatch,
	navigate,
	setLogin,
	setManagerDetails,
	clearDashboardFetchCache,
	onDenied,
	onFailure,
}) => {
	const status = responseBody?.status;
	if (status !== 200) {
		onFailure?.(parseStaffApiError(responseBody, "Request failed."));
		return false;
	}

	const role = responseBody.data?.role;
	if (!role || !STAFF_ROLES.includes(role)) {
		onDenied?.();
		return false;
	}

	clearDashboardFetchCache?.();
	dispatch(
		setLogin({
			user: responseBody.data.user_details,
			token: responseBody.data.token.token,
			admin: responseBody.data.admin ?? (role === "admin" ? 1 : 0),
			role,
			relationshipManager: responseBody.data.relationship_manager ?? null,
			assignedPropertyIds: responseBody.data.assigned_property_ids ?? [],
			assignedLandlordIds: responseBody.data.assigned_landlord_ids ?? [],
			broker: responseBody.data.broker ?? null,
		})
	);
	if (role === "manager" && responseBody.data.manager) {
		dispatch(setManagerDetails(responseBody.data.manager));
	}
	navigate(role === "broker" ? "/broker-commissions" : "/home");
	return true;
};
